import React, { useRef, useEffect } from "react";
import styles from "./EditorEmbed.module.scss";

const Embed = ({ value }) => {
  const ref = useRef();
  useEffect(() => {
    const parsedHTML = document.createRange().createContextualFragment(value);
    ref.current.appendChild(parsedHTML);
  }, [value]);

  return (
    <div
      ref={ref}
      className={value.includes("<iframe ") > 0 && styles.iframeContainer}
    />
  );
};

export default Embed;
